<template>
    <section class="banner">
        
        <el-carousel class="banner_img" trigger="click">
            <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                <a :href="item.linkurl" target="_blank">
                    <img :src="item.linkimg">
                </a>
            </el-carousel-item>

            <div class="index_login" v-if="$siteConfig.bannerShowLogin">
                <div class="block">
                    <div class="flex">
                        <a href="/login" class="user" title="登录">
                            <img src="/images/user.png">登录
                        </a>
                        <a :href="`/register?plan=${$siteConfig.planName}`" class="register" title="没有账号？立即注册">
                            免费注册
                        </a>
                    </div>
                </div>
                <div class="bg"></div>
            </div>
        </el-carousel>
        <!-- <div class="data" v-if="dataList.length > 0">
            <div class="title">
                今日交易
            </div>

            <div class="con">
                <div 
                class="item"
                v-for="(item, index) in dataList"
                :key="index"
                >
                    <div class="num">
                        {{item.num}}
                    </div>
                    <div class="text">
                        {{item.title}}
                    </div>
                </div>
            </div>
        </div>
        <div class="data" style="bottom:0" v-if="rzjgList.length > 0">
            <div class="title">
                入驻机构
            </div>

            <div class="con">
                <div 
                class="item"
                v-for="(item, index) in rzjgList"
                @click="linkList(item.title)"
                style="cursor: pointer;"
                :key="index"
                >
                    <div class="num">
                        {{item.num}}
                    </div>
                    <div class="text">
                        {{item.title}}
                    </div>
                </div>
            </div>
        </div> -->
    </section>
</template>

<script>
export default {
    data() {
        return {
            title: this.$siteConfig.title,
            hotList: ['政府采购', '企业采购'],
            bannerList:[],
            dataList: [],
            rzjgList:[]
        };
    },
    methods: {
        searchHandler() {
            this.goto({
                path: '/business',
                query: {
                    searchcontent: this.searchText,
                },
            })
        },
        // 跳转代理机构列表页
        linkList(title){
            if(title=='代理'){
                this.goto({
                    path: '/info/list',
                    
                })
            }
        }
    },
    created() {
        var that = this;
        this.$get(`${this.$store.state.api.webUrl}/index/information/indexinfoextra.json`, {
            featurecode:this.$siteConfig.planName,
        }, data => {
            if(this.$siteName === 'nm'){
                that.rzjgList = [
                    {
                        title: '代理',
                        num: data.zhuceshuliang.daili,
                    },
                    {
                        title: '投标人',
                        num: data.zhuceshuliang.toubiaoren,
                    },
                    {
                        title: '招标人',
                        num: data.zhuceshuliang.zhaobiaoren,
                    },
                ]
            }else{
                that.dataList = [ {
                    title: '采购公告',
                    num: data.jinrijiaoyi.caigougonggaocount,
                },
                {
                    title: '开标',
                    num: data.jinrijiaoyi.kaibiaocount,
                },
                {
                    title: '评标',
                    num: data.jinrijiaoyi.pingbiaocount,
                },
                {
                    title: '中标',
                    num: data.jinrijiaoyi.zhongbiaocount,
                }];
            }
        });
        // 获取轮播图
        this.$get(`${this.$store.state.api.webUrl}/index/information/getcarouselpic.json`,  {
            featurecode:this.$siteConfig.planName,
        }, data => {
            if(data.length==0){
                this.bannerList = this.$siteConfig.bannerList;
            }else{
                this.bannerList = data;
            }
            
        })
    },
};
</script>

<style lang="scss" scoped>
    @import '@css/var.scss';

    .banner{
        box-sizing: border-box;
        height: 440px;
        background-size: cover;
        background-position: center cetner;
        position: relative;

        .banner_img{
            height: 440px;
            width: 100%;

            ::v-deep .el-carousel__container{
                height: 440px;
            }
            img{ width: 100%;height:100%; }
        }

        .index_login{
            width: 1200px;
            margin: 0 auto;
            color: #fff;
            position: relative;
 

            .bg{
                width: 330px;
                height: 440px;
                display: block;
                background-color: #000;
                position: absolute;
                right: 0px;
                top: 0px;
                filter: alpha(opacity=70);
                -moz-opacity: 0.7;
                opacity: 0.7;
                z-index: 5;
            }

            .block {
                width: 330px;
                height: 440px;
                display: block;
                position: absolute;
                right: 0px;
                top: 0px;
                z-index: 6;

                .flex{
                    display: flex;
                    flex-flow: column;
                    align-items: center;
                    margin-top: 120px;
                }

                a{
                    height: 64px;
                    width: 254px;
                    display: inline-block;
                    text-align: center;
                    font-size: 18px;
                    font-weight: 500;
                    color: #fff;
                    background: #2079db;
                    line-height: 64px;
                    margin-bottom: 20px;
                    border-radius: 5px;
                    z-index: 5;
                }
                
                .user{
                    width: 254px;
                    background: #2252e7;
                    font-weight: 400;
                    letter-spacing: 1px;
                    img{
                        width:26px;
                        height:26px;
                        vertical-align: middle;
                        margin-right: 10px;
                        margin-top: -5px;
                    }
                }

                .register{
                    background: #f3f5f7;
                    letter-spacing: 1px;
                    color: #000;
                    border: 1px solid #f3f5f7;
                    margin-top: 20px;
                }
            }
        }

        .search{
            width: 570px;
            margin: 0 auto;

            h1{
                color: #ffffff;
                font-size: 28px;
                font-weight: normal;
                letter-spacing: 2px;
                text-align: center;
                cursor: default;
                margin-bottom: 1em;
            }

            .input-search{
                ::v-deep {
                    .el-input__inner, .el-input-group__append{
                        border-radius: 0;
                        border: none;
                    }

                    .el-input-group__append{
                        background: white;
                        position: relative;
                        color: $primaryColor;
                        padding: 0 24px;

                        &:after{
                            content: '';
                            display: block;
                            width: 1px;
                            height: 24px;
                            background: $primaryColor;
                            position: absolute;
                            left: 0;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                }
            }

            .hot{
                margin-top: 1.2em;

                span {
                    cursor: default;
                    color: white;

                    &.itme {
                        cursor: pointer;

                        & + .itme{
                            margin-left: 1em;
                        }

                        &:hover{
                            font-weight: bold;
                        }
                    }
                }
            }
        }

        .data{
            width: 1200px;
            overflow: hidden;
            cursor: default;
            text-align: center;
            background: white;
            padding: 24px 0 18px;
            position: absolute;
            bottom: -70px;
            left: 50%;
            transform: translate(-50%, 50%);
            box-shadow: 0 5px 5px #E6E7E9;
            z-index: 10;

            .title{
                float: left;
                font-size: 18px;
                color: #1b1b1b;
                width: 126px;
                margin-right: -126px;
                margin-top: 10px;
                position: relative;

                &:after{
                    content: '';
                    display: block;
                    width: 1px;
                    height: 28px;
                    background: #a4a4a4;
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }

            .con{
                margin-left: 126px;
                overflow: hidden;

                .item{
                    float: left;
                    width: 25%;

                    .num {
                        font-size: 26px;
                        font-weight: bold;
                        color: $primaryColor;
                        line-height: 1em;
                    }

                    .text{
                        line-height: 1em;
                        margin-top: 10px;
                        color: #3c3c3c;
                    }
                }
            }
        }
    }
</style>